export default __webpack_public_path__ + "static/media/icon_math.48e67d95.png";